module.exports = __webpack_public_path__ + "img/30_8.48558acd.png";